if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.applyPopupLayout();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        const newSectionId = `quickadd-${sectionId}`;

        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, newSectionId);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });

        // Only the *inner* contents of the fetched <section id="MainProduct-...">, never the
        // section element itself, get injected into the modal. That means every stylesheet rule
        // scoped to that section's own id/class (e.g. "#MainProduct-{id}" or
        // ".section-{id}-padding") never matches inside the modal, since nothing in the modal
        // carries that id/class. Recreate those attributes (renamed to match the ids rewritten
        // above) on the modal's content wrapper so the popup renders identically to the product page.
        if (this.contentClasses) this.modalContent.classList.remove(...this.contentClasses);
        this.contentClasses = Array.from(this.productElement.classList).map((classApplied) =>
          classApplied.includes(sectionId) ? classApplied.replace(sectionId, newSectionId) : classApplied
        );
        this.modalContent.classList.add(...this.contentClasses);
        this.modalContent.id = `MainProduct-${newSectionId}`;
        this.modalContent.dataset.section = newSectionId;
      }

      applyPopupLayout() {
        // No price shown in the popup.
        const priceBlock = this.productElement.querySelector('[id^="price-"]');
        if (priceBlock) priceBlock.remove();

        // Thumbnails always render as a single row of 5 in the popup, regardless
        // of the section's own thumbnail settings on the product page.
        const galleryContainer = this.productElement.querySelector('[data-thumbs-rows]');
        if (galleryContainer) {
          galleryContainer.setAttribute('data-thumbs-rows', '1');
          galleryContainer.setAttribute('data-thumbs-per-row', '5');
        }

        // "View full details" link isn't needed in the popup, since the user
        // is already viewing the product's full details.
        const viewDetailsLink = this.productElement.querySelector('.product__view-details');
        if (viewDetailsLink) viewDetailsLink.remove();
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
